import * as stylex from "@stylexjs/stylex";
import { useContentRect } from "../hooks";
import { layout } from "../materials/layout.stylex";
import { BarChart as FixedWidthBarChart } from "./lib/Bars";
export function BarChart(props) {
    const [ref, contentRect] = useContentRect();
    return <div ref={ref} {...stylex.props(layout.fullWidth)}>
      {contentRect.width > 0 && <FixedWidthBarChart {...props} width={contentRect.width}/>}
    </div>;
}
